//* 组件库引入
import { $loading } from "various-ui";
//* 函数库引入
import { Formats } from "@/assets/js";
//* 组件属性
import { useDiseaseOption, useGeneOption, useModelOption, useMutationOption, useToolOption } from "./options";

export const useComposable = () => {
    //* 获取route
    const route = useRoute();
    const i18n = useI18n();

    //* 表格配置
    const diseaseOption = useDiseaseOption();
    const geneOption = useGeneOption();
    const modelOption = useModelOption();
    const mutationOption = useMutationOption();
    const toolOption = useToolOption();

    //* 响应式数据
    const refs = {
        data: ref<{ [name: string]: any }>(),
        cards: ref<any>(),
        database: ref<string[]>([]),
    };

    //* 节点
    const nodes = {
        ListNode: ref<HTMLDivElement[]>(),
        DiseaseListNode: ref<HTMLDivElement>(),
        GeneListNode: ref<HTMLDivElement>(),
        ModelListNode: ref<HTMLDivElement>(),
    };

    //* 函数列表
    const methods = {
        initCards: (response: any) => {
            const cardContainer = [
                {
                    data: response.disease || {},
                    route: "SearchDisease",
                    title: i18n.t("Layout.TypeDatabase", { type: "Disease" }),
                    more: i18n.t("Layout.TypeMore", { type: "Disease" }),
                    key: "Disease",
                    option: diseaseOption,
                },
                {
                    data: response.gene || {},
                    route: "SearchGene",
                    title: i18n.t("Layout.TypeDatabase", { type: "Gene" }),
                    more: i18n.t("Layout.TypeMore", { type: "Gene" }),
                    key: "Gene",
                    option: geneOption,
                },
                {
                    data: response.model || {},
                    route: "SearchModel",
                    title: i18n.t("Layout.TypeDatabase", { type: "Model" }),
                    more: i18n.t("Layout.TypeMore", { type: "Model" }),
                    key: "Model",
                    option: modelOption,
                },
            ];

            const mutationCard = {
                data: response.mutation || {},
                route: "SearchMutation",
                title: i18n.t("Layout.TypeDatabase", { type: "Mutation" }),
                more: i18n.t("Layout.TypeMore", { type: "Mutation" }),
                key: "Mutation",
                option: mutationOption,
            };

            const toolCard = {
                data: response.tool || {},
                route: "SearchTool",
                title: i18n.t("Tools", 2),
                more: i18n.t("Layout.TypeMore", { type: "Tool" }),
                key: "Tool",
                option: toolOption,
            };

            //* 全部空值，固定顺序 基因-疾病-突变-模型
            if (response.disease.count == 0 && response.gene.count == 0 && response.model.count == 0 && response.mutation.count == 0) {
                refs.cards.value = [cardContainer[1], cardContainer[0], mutationCard, cardContainer[2], toolCard];
            } else {
                if (response.reverse) {
                    cardContainer.unshift(mutationCard);
                } else {
                    cardContainer.push(mutationCard);
                }
                cardContainer.push(toolCard);

                refs.cards.value = cardContainer.sort((a, b) => (b.data?.count == 0 ? -1 : 0));
            }
        },

        //* 跳转函数
        next: (data: any, routeName: string) => {
            if (!data.count) return "";
            else {
                const keyword = Formats.query(route.query.keyword)?.trim();
                return {
                    name: routeName,
                    query: {
                        ...(keyword && { keyword }),
                        date: Date.now().toString(),
                    },
                };
            }
        },
    };
    //* 触发事件
    const ons = {
        diagram: {
            click: (data: any) => {
                if (data?.mode) {
                    if (data?.mode == "Gene") {
                        return open(
                            routerResolve({ name: data?.mode, params: { id: data?.id }, query: { keyword: Formats.query(route.query.keyword) } })
                                .href as string,
                            "_blank"
                        );
                    } else {
                        return open(routerResolve({ name: data?.mode, params: { id: data?.id } }).href as string, "_blank");
                    }
                }
            },
        },
    };
    //* 侦听器
    const watchs = {
        stopHandler: watch(
            () => route.query.keyword,
            () => {
                //* 开启Loading, 如果在3毫秒内关闭则不会出现
                $loading.open({ delay: 300, message: "" });
                //* 数据请求
                api.frontend("/api/search", {
                    data: { keyword: Formats.query(route.query.keyword) },
                    method: "POST",
                    success: (response) => {
                        methods.initCards(response);
                    },
                    finally: () => {
                        $loading.close();
                    },
                });
            }
        ),
    };

    return { refs, nodes, methods, watchs, ons };
};
